export default __webpack_public_path__ + "static/media/rewardMobTest.3dca74c1.png";